import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const oesophageal: ModelConfigParams = {
  bodyParts: [
    'tumour',
    'artery', // aorta
    'vein', // vena cava
    'veinUncertain', // pulmonary vein
    'oesophagus',
    'airwayWithDetail',
    'heart', // pericardium
    'thoracicDuct',
    'crus', // https://en.wikipedia.org/wiki/Crus_of_diaphragm
    'bone',
    'aorta',
    'azygosVein'
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [-100, 300],
  internal: true,
}
